// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase'

const firebaseConfig = {
  apiKey: 'AIzaSyDKh42F27SAnCvssvPURLKmB1dEstmD-jA',
  authDomain: 'video-chat-717f6.firebaseapp.com',
  databaseURL: 'https://video-chat-717f6.firebaseio.com',
  projectId: 'video-chat-717f6',
  storageBucket: 'video-chat-717f6.appspot.com',
  messagingSenderId: '222646517633',
  appId: '1:222646517633:web:7cd6c2aa2f5c89fd9f3280',
  measurementId: 'G-41ESGV8EBP'
}

const firebaseApp = firebase.initializeApp(firebaseConfig)
export default firebaseApp.firestore()
